import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type {
  Control_Bool_Exp,
  GetControlCountQuery,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetControlCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

type ControlCountArgs = NavigationCountArgs & {
  // The equivalent Hasura bool_exp — drives the GraphQL fallback so the
  // flag-gated twin counts identically. Built by useEntityWhereFilter.
  where?: Control_Bool_Exp;
};

export const useGetControlCount = createQueryHook<
  ControlCountArgs,
  NavigationCounts,
  GetControlCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    control_aggregate: { aggregate: toAggregate(data.control) },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetControlCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
